/**
 * GL215 S2, Buzz spoor 1 E-licht: het gesprek als dossier (`GET /conversations/<id>/dossier`).
 * De dienst geeft een zip met de naam in de kop `Content-Disposition`.
 */
export const DOSSIER = "dossier";

/** De bestandsnaam uit de kop, of een vaste terugval. PUUR. */
export function naamUitKop(kop) {
  const m = /filename="([^"]+)"/.exec(kop || "");
  return m && m[1] && !/[\\/]/.test(m[1]) ? m[1] : "dossier.zip";
}
